import validationRules from './validation-rules';
import isPromise from 'utils/isPromise';
import getIn from './getIn';

const fieldValidationRules = {};

export const addValidation = (key, fn) => (fieldValidationRules[key] = fn);
export const addValidations = validationRules =>
  Object.keys(validationRules).forEach(key => addValidation(key, validationRules[key]));
addValidations(validationRules);

export function createValidationRules(fieldValidationConfig, registeredFields) {
  return (values, dispatch, props) => {
    const promiseList = [Promise.resolve()];
    const errors = {};

    function addError(field, validationType, message = true) {
      if (!errors[field]) {
        errors[field] = {};
      }
      errors[field][validationType] = message;
    }

    Object.keys(fieldValidationConfig).forEach(fieldName => {
      let fieldValidator = (validation, touched, innerFieldName) => {
        if (typeof validation === 'object' && touched) {
          Object.keys(validation).forEach(validationType => {
            if (typeof fieldValidationRules[validationType] !== 'function') {
              return;
            }

            const hasError = fieldValidationRules[validationType](
              fieldName,
              getIn(values, innerFieldName),
              validation[validationType],
              dispatch,
              values,
              validation
            );
            if (isPromise(hasError)) {
              promiseList.push(
                new Promise(resolve => {
                  hasError.then(resolve).catch(msg => {
                    addError(innerFieldName, validationType, msg);
                    resolve();
                  });
                })
              );
            } else if (hasError) {
              addError(innerFieldName, validationType, hasError);
            }
          });
        }
      };

      const validation = fieldValidationConfig[fieldName];

      let itemScanner;
      itemScanner = (tempObj, scanList, index, innerFieldName) => {
        let item = getIn(tempObj, scanList[index]);
        if (Array.isArray(item)) {
          let items = [];
          for (let i = 0; i < item.length; i++) {
            itemScanner(
              item[i],
              scanList,
              index + 1,
              (innerFieldName === '' ? '' : innerFieldName + '.') + scanList[index] + '.' + i
            );
          }
          return items;
        } else if (index + 1 < scanList.length) {
          itemScanner(item, scanList, index + 1, innerFieldName + (innerFieldName === '' ? '' : '.') + scanList[index]);
        } else {
          fieldValidator(validation, item, innerFieldName);
        }
      };

      itemScanner(props.fields, `${fieldName}.touched`.split('.'), 0, '');
    });
    return Promise.all(promiseList).then(() => {
      if (Object.keys(errors).length) {
        return Promise.reject(errors);
      }
    });
  };
}

export function checkGivenType(type, fieldValue) {
  if (type === 'BigDecimal') {
    if (fieldValue !== null && fieldValue !== undefined && fieldValue !== +fieldValue) {
      return 'Must be a number which can include decimal places';
    }
  }
  if (type === 'Long') {
    if (
      fieldValue !== null &&
      fieldValue !== undefined &&
      fieldValue !== +fieldValue &&
      fieldValue !== (fieldValue | 0)
    ) {
      return 'Must be a whole number';
    }
  }
  if (type === 'LocalDate') {
    if (fieldValue !== null && fieldValue !== undefined) {
      const d = new Date(fieldValue);
      if (d.toString() === 'Invalid Date') {
        return 'Invalid Date';
      }
    }
  }
  return false;
}
